__turbopack_context__.v({
  "combined_input_container": "styles-module-scss-module__rxEHDG__combined_input_container",
  "combined_input_wrapper": "styles-module-scss-module__rxEHDG__combined_input_wrapper",
  "input_field": "styles-module-scss-module__rxEHDG__input_field",
  "input_label": "styles-module-scss-module__rxEHDG__input_label",
  "left_input": "styles-module-scss-module__rxEHDG__left_input",
  "percent_symbol": "styles-module-scss-module__rxEHDG__percent_symbol",
  "right_input": "styles-module-scss-module__rxEHDG__right_input",
});
